import type { TStatistics, TStatisticsServer } from '../../store/types';

const statisticsItemAdapter = (item: TStatisticsServer): TStatistics => ({
  currency: item.currency,
  totalRequests: item.total_requests,
  totalApproved: item.total_approved,
  transactionsCount: item.transactions_count,
  transactionsAmount: item.transactions_amount,
  remoteTransactionsCount: item.remote_transactions_count,
  remoteTransactionsAmount: item.remote_transactions_amount,
  customTransactionsCount: item.custom_transactions_count,
  customTransactionsAmount: item.custom_transactions_amount,
  activeWithdrawalsAmount: item.active_withdrawals_amount,
  approvedWithdrawalsAmount: item.approved_withdrawals_amount,
  totalBalance: item.total_balance,
});

export const statisticsAdapter = (items: TStatisticsServer[]): TStatistics[] => items.map(statisticsItemAdapter);
